module.exports = __webpack_public_path__ + "tickets-white.svg?ae063cf7164384ff77d639d2aa53d3c4";